import { Checkbox } from "../ui/checkbox";

type ConsentCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
};

export default function ConsentCheckbox({
  checked,
  onChange,
  label = "I agree to the Terms & Conditions",
}: ConsentCheckboxProps) {
  return (
    <label className="flex gap-2 w-full items-center max-w-[320px]">
      <Checkbox
        checked={checked}
        className="
        h-5 w-5 rounded-lg
        border border-gray-300
        accent-transparent
        checked:border-2
        checked:ring-1 checked:ring-black checked:rounded-lg
        focus:outline-none 
      "
        onCheckedChange={(checked) => {
          if (checked) {
            onChange(true);
          } else {
            onChange(false);
          }
        }}
      />
      <span className="text-sm text-[#0C111D]">{label}</span>
    </label>
  );
}
